<template>
  <div>
    <Layout>
      <Card>
        <p slot="title">健康档案</p>
        
        <div class="search-box">
          <Button v-if="user.roleType==user.doctorTypeE.GLY" type="primary" @click="revamp = true" class="add-btn"
            >+ 新建档案</Button
          >
          <Input
            v-model="tableparam.mobile"
            placeholder="按手机号查询"
            search
            enter-button="搜索"
            :style="{ width: '250px' }"
            @on-search="tableQuery"
          />
          <div class="search-tag-wrapper">
          <div class="search-tag-label">我的客户</div>
          <div class="search-tag-value">{{statisticsdata.count}}</div>
          </div>

          <div class="search-tag-wrapper">
            <div class="search-tag-label">本月新增客户</div>
            <div class="search-tag-value">{{statisticsdata.localMonthCount}}</div>
          </div>
        </div>
        
       <div v-if="inited" class="content">
        <el-table id="cachetable" :data="tabledata" @row-click="openUserBasicInfo" :height="tableHeight">
          <el-table-column prop="id" align="center" minWidth="80" label="编号"></el-table-column>
          <el-table-column align="center"  minWidth="100"  label="操作">
            <div slot-scope="scope" class="table-action">
              <template v-for="(action,index) in actions">
               <div class="table-action-item" :key="'action'+index" @click.stop="doAction(action,scope.row)">{{action.title}}<div class="table-action-item-pot" v-if="scope.row['id']"></div></div>
              </template>
            </div>
          </el-table-column>
          <el-table-column prop="avatar" align="center" minWidth="80" label="微信头像">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" />
            </template>
          </el-table-column>
          <el-table-column prop="name" align="center" minWidth="100" label="昵称"></el-table-column>
          <el-table-column prop="mobile" align="center" minWidth="110" label="手机号"></el-table-column>
          <el-table-column prop="gender" align="center" minWidth="60" label="性别"></el-table-column>
          <el-table-column prop="birth" align="center" minWidth="100" label="出生日期"></el-table-column>
          <el-table-column prop="birth" align="center" minWidth="80" label="等级">
            <template slot-scope="scope">
              {{user.memberTypeMap[scope.row.memberType]}}
            </template>
          </el-table-column>
          <el-table-column prop="orgName" align="center" minWidth="100" label="机构"></el-table-column>
          <el-table-column prop="teamName" align="center" minWidth="100" label="团队"></el-table-column>
          <el-table-column prop="doctorName" align="center" minWidth="100" label="咨询师"></el-table-column>
          <!-- <el-table-column prop="name" align="center" minWidth="150" label="姓名"></el-table-column>
          <el-table-column prop="mobile" align="center" minWidth="150" label="手机号"></el-table-column>
          <el-table-column prop="gender" align="center" minWidth="120" label="性别"></el-table-column>
          <el-table-column prop="birth" align="center" minWidth="150" label="出生日期"></el-table-column>
          <el-table-column prop="memberType" align="center" minWidth="150" label="会员等级">
            <template slot-scope="scope">
              {{user.memberTypeMap[scope.row.memberType]}}
            </template>
          </el-table-column>
          <el-table-column prop="nickName" align="center" minWidth="150" label="微信昵称"></el-table-column>
          <el-table-column prop="avatar" align="center" minWidth="120" label="微信头像">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" />
            </template>
          </el-table-column> -->
          <!-- <template v-for="(team, index) in teams">
            <el-table-column :key="'team'+index" align="center" minWidth="140" :label="team.teamlabel+'团队'">
              <template slot-scope="scope">
                {{scope.row[team.teamKey]}}
              </template>
            </el-table-column>
            <el-table-column :key="'member'+index" align="center"  minWidth="150"  :label="team.teamlabel">
              <template slot-scope="scope">
                {{scope.row[team.memberKey]}}
              </template>
            </el-table-column>
            <el-table-column v-if="team.bindTime" align="center" :key="'time'+index"  prop="bindTime" minWidth="160" label="绑定时间"></el-table-column>
          </template> -->


        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="tableparam.page"
          :page-size="tableparam.pageSize"
          @current-change="handleCurrentChange"
          :total="tableparam.total"
        ></el-pagination>
        
      </div>
      </Card>
      
      <el-dialog append-to-body  title="新建档案" :visible.sync="revamp" minWidth="480px">
          <el-form style="padding:30px 20px;" :model="form" :rules="rules" ref="form" class="newkhdn">
            <el-form-item
              label="姓名："
              prop="name"
              :label-width="formLabelWidth"
            >
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item
              label="性别："
              prop="gender"
              :label-width="formLabelWidth"
            >
              <el-select v-model="form.gender">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="出生年月："
              prop="birth"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                v-model="form.birth"
                width="100%"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="手机号："
              prop="mobile"
              :label-width="formLabelWidth"
            >
              <el-input v-model="form.mobile" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <Button @click="revamp = false">取 消</Button>
            <Button class="okButton" type="primary" @click="newlykhda('form')">确 定</Button>
          </div>
        </el-dialog>
    </Layout>
  </div>
</template>
<script>
import { api } from "@/request/api";
export default {
  components: {
    
  },
  data() {
    return {
      tableparam:{
        total: 0,
        page: 1,
        pageSize: 20,
        mobile: "",
      },
      tableHeight:100,
      inited:false,
      tabledata: [],
      revamp: false,
      formLabelWidth: "100px",
      statisticsdata:{},
      teams:[],
      actions:[

      ],
      form: {
        name: "",
        gender: "",
        birth: "",
        mobile: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名字", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        birth: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "change" },
        ],
      },
    };
  },
  mounted(){

  },
  created() {
    var that=this;
    that.initData();
  },
  methods: {
    initData(){

      var that=this;
      that.actions=[
        {title:"消息",id:'xx'},
        {title:"方案",id:'fa'}
      ];

      that.defaultTable(that);
      console.log("------------------------------------0010");
      that.tableQuery();
//      var load=that.initTableCacheWithRoutere(that);
//      load = false;
//      if(load){
//        that.tableQuery();
//        //that.statistc();
//      }
    },
    openUserBasicInfo(row) {
      this.notificationCenter.postNotificationName('openUserBasicInfo',row);
    },
    doAction(action,row){
      if(action.id=='fa'){
        this.notificationCenter.postNotificationName('openZsfaRecordListDialog',{userId:row.id});
      }
      else if(action.id=='xx'){
        this.notificationCenter.postNotificationName('openNewsRecordListDialog',{userId:row.id});
      }
    },
    statistc(){
      var that=this;
      console.log(11124);
      api.healthFileStatistic().then((response) => {
        response = response.data;
        if (response.code == 0) {
          that.statisticsdata = response.data;
          that.cache.statisticsdata=that.statisticsdata;
        }
        else{
          that.$message.error(response.msg);
        }
      });
    },
    tableQuery() {
      console.log(8889);
      //列表
      var that = this;
      var parameter = {
        mobile: that.tableparam.mobile,
        page: that.tableparam.page,
        pageSize: that.tableparam.pageSize,
      };
      console.log('that.tableparam1',that.tableparam);
      api.healthFileQuery(parameter).then((response) => {
        response = response.data;
        if (response.code === 0) {
          that.tableparam.total = response.page.totalCount;
          that.tabledata = response.page.list;
          that.cache.tableparam=that.tableparam;
          that.cache.tabledata=that.tabledata;
        }
      });
    },
    handleCurrentChange(cpage) {
      //分页
      this.tableparam.page = cpage;
      this.tableQuery();
    },
    newlykhda(formName) {
      var that = this;
      var parameter = that.form;
      parameter.birth = Date.parse(parameter.birth);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.jkdaadd(parameter).then((response) => {
            response = response.data;
            if (response.code == 0) {
              that.revamp = false;
              that.tableQuery();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.okButton
{
  margin-left:10px;
}
.search-box {
  display: flex;
  .add-btn {
    margin-right: 10px;
  }
}
.content img {
  width: 40px;
}
.newkhdn {
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-select {
    display: block;
  }

}
.search-tag-wrapper
{
  width: 134px;
  height: 31px;
  background: #D5E4FF;
  border-radius: 3px;
  opacity: 0.58;
  display:flex;
  justify-content: space-around;
  align-items: center;
  margin-left: 20px;
  .search-tag-label
  {
    font-size: 11px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
  .search-tag-value
  {
    font-size: 18px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 500;
    color: #264AFF;
  }
}
.table-action{
  display: flex;
  align-items: center;
  justify-content: center;
  
}
.table-action-item{
  
}
.table-action-item{
 position: relative;
 padding: 4px;
}
.table-action-item-pot{
  background: red;
    width: 4px;
    height: 4px;
    border-radius: 2px;
    position: absolute;
    top: 4px;
    right: 4px;
}
/deep/.el-table__body{
  overflow: scroll;
}
</style>
